import React from 'react';
import { Outlet } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { StatusStrip } from './StatusStrip';
import { Toaster } from '@/components/ui/sonner';

export const AppShell = () => {
  const { persona } = useApp();
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* WCAG 2.4.1 — Skip to main content */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-3 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        Skip to main content
      </a>
      <TopBar />
      <div className="flex flex-1 min-h-0">
        <Sidebar persona={persona} />
        <main
          id="main-content"
          tabIndex="-1"
          className="flex-1 min-w-0 overflow-y-auto scrollbar-thin focus:outline-none"
        >
          <div className="max-w-[1600px] mx-auto px-6 py-6">
            <Outlet />
          </div>
        </main>
      </div>
      <StatusStrip />
      <Toaster richColors closeButton position="top-right" />
    </div>
  );
};

export default AppShell;
